export const addRedPeriod = (text) => {
  if (text.endsWith('.')) {
    text = text.slice(0, -1) + '<span style="color:red">.</span>'
  }
  return text;
};
